export default [
  {
    path: "/settings/contact-information",
    name: "ContactInformation",
    component: () => import("@/views/Ondemand/Settings/ContactInformation.vue"),
  },
  {
    path: "/settings/account-security",
    name: "AccountSecurity",
    component: () => import("@/views/Ondemand/AccountSecurity.vue"),
  },
  {
    path: "/settings/select",
    name: "SettingsSelect",
    component: () => import("@/views/Ondemand/Settings/SettingsPage.vue"),
  },
  {
    path: "/settings/domain",
    name: "SettingsDomain",
    component: () => import("@/views/Ondemand/Domains.vue"),
  },
  {
    path: "/settings/payment",
    name: "SettingsPayment",
    component: () => import("@/views/Ondemand/Settings/Payment.vue"),
  },
  {
    path: "/settings/wallet-details",
    name: "SettingsWalletDetails",
    component: () => import("@/views/Ondemand/Settings/WalletDetails.vue"),
  },
  {
    path: "/settings/cards",
    name: "SettingsCardsDetails",
    component: () => import("@/views/Ondemand/Settings/Cards.vue"),
  },
];
